import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { BudgetState } from './budget.model';
import { BudgetStore } from './budget.store';

@Injectable({ providedIn: 'root' })
export class BudgetQuery extends Query<BudgetState> {
  constructor(protected store: BudgetStore) {
    super(store);
  }
}
